export default __webpack_public_path__ + "static/media/curved-arrow.d2a47c59.svg";